import { render, staticRenderFns } from "./CostSummary.vue?vue&type=template&id=70b8d3de&scoped=true&"
import script from "./CostSummary.vue?vue&type=script&lang=js&"
export * from "./CostSummary.vue?vue&type=script&lang=js&"
import style0 from "./CostSummary.vue?vue&type=style&index=0&id=70b8d3de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b8d3de",
  null
  
)

export default component.exports